import React from "react";
import './privacypolicy.css';

function PrivacyPolicy (){

    const openNewTab =(url)=>{
        window.open(url, '_blank')
    }
    return (
        <div style={{marginLeft:5, marginRight:5,}}>
                        
            <p style={{textAlign:'center', fontSize:28}}>VODAFONE FIJI</p>
            <p style={{textAlign:'center', fontSize:28}}>M-PAiSA</p>
            <p style={{textAlign:'center', fontSize:28}}><strong>Our Privacy Policy</strong></p>

            <div>
                <h3>
                    The home of our privacy and cookie policy
                </h3>
                <p>Your privacy is important to us - just as knowing how we use your information is important to you. Our Privacy Portal gives you full visibility of how we collect, use, share and
                    protect your personal information when you use our products, services and our websites.
                </p>
                <p>
                    We've broken this information down into parts so you can find the deetails you need as quickly and easily as possible.
                </p>
            </div>

            <div>
                <h3>
                    Privacy Policy
                </h3>
                <h4>
                    About our privacy and cookies policy
                </h4>
                <p>
                    Our privacy and cookies policy gets updated from time to time. Whenever we make a change, we'll post this on our website and let you know if there is a material change.
                </p>
                <p>
                    We have revised our privacy and cookies policy, refreshing it to tie in with the launch of our new Privacy Portal.
                </p>
                <h4>
                    Last updated: 30 May 2019
                </h4>

            </div>
            <div>
                <h3>
                    How to use this privacy and cookies policy
                </h3>
                <p>
                    In this policy, we explain how we collect, use, share and protect your personal information when you use our products and services and our website.
                </p>
                <h4>
                    Who we are
                </h4>
                <p>
                    We are Vodafone Fiji Pte Limited.
                </p>
                <p>
                    In this privacy policy:
                    <ul>
                        <li>"we/us" means Vodafone Fiji Pte Limited</li>
                        <li>"third party" means someone who is not you or us</li>
                    </ul>
                </p>
            </div>
            <div>
                <h3>How to contact us</h3>
                <p>
                    Your opinion matters to us - if you have any questions about our privacy policy or your privacy settings, please
                    submit your query and a member of our dedicated team will respond to you. You can send an email directly to&nbsp;
                    <a href="mailto:info@vodafone.com.fj">info@vodafone.com.fj</a>.
                </p>
            </div>
            <div>
                <h3>Our principles</h3>
                <p>
                Vodafone is committed to respecting your privacy. We take privacy, security and complying with data protection
                and privacy laws seriously.
                Here are Vodafone's core <a href="https://www.vodafone.com.fj/about/privacy-policy">Privacy Commitments</a>. We aim to put these commitments at the heart of everything we
                do.
                </p>

            </div>

            <div>
                <h3>
                    Personal Information we collect about you 
                </h3>
                <p>
                    The information we collect about you and how we collect it can vary depending on the products and services that
                    you use and subscribe to, how you have used the products and services, and how you have interacted with Vodafone
                    even if you aren't a customer, or what we have obtained from a third party with permission to share it with us.
                </p>
                <p>
                    Vodafone will process your personal data based on:
                </p>
                <ul>
                    <li>
                        <strong>The performance of your contract or to enter into the contract</strong> and to take action on your requests. For
                        example, so you can make calls and texts, and browse the internet or use an app on your phone, we process
                        things like the numbers you dial, how much data you're using and when you're doing it so we can provide
                        connectivity. This also enables us to generate your bill, based on your usage.
                    </li>
                    <li>
                        <strong>Vodafone's legitimate business interests,</strong> for example, fraud prevention, maintaining the security of our
                        network and services, direct marketing, and the improvement of our services. Whenever we rely on this
                        lawful basis to process your data, we assess our business interests to make sure they do not override your
                        rights. Additionally, in some cases you have the right to object to this processing. For more information,
                        send us an email on <a href="info@vodafone.com.fj">info@vodafone.com.fj</a>.
                    </li>
                    <li>
                        <strong>Compliance with a mandatory legal obligation,</strong> including for example accounting and tax requirements,
                        which are subject to strict internal policies (such as retention periods), procedures, and your right to restrict
                        usage of your data, which control the scope of legal assistance to be provided.
                    </li>
                    <li>
                        <strong>Consent you provide</strong> where Vodafone does not rely on another legal basis. Consent may be withdrawn at
                        any time. When you give your consent, you will be given details on how to change your mind. For more
                        information on this, send us an email on <a href="info@vodafone.com.fj">info@vodafone.com.fj</a>.
                    </li>
                </ul>
            </div>
            <div>
                <p>
                We will collect your personal information when you, for example:
                </p>
                <ul>
                    <li>Buy or use any of our products and services</li>
                    <li>Use our network or other Vodafone products and services</li> 
                    <li>Register for a specific product or service</li>
                    <li>Subscribe to newsletters, alerts or other services from us</li>
                    <li>Contact us through various channels, or ask for information about a product or service</li>
                    <li>Take part in a competition, prize draw or survey</li>
                    <li>Visit or browse our website</li>
                    <li>Have given permission to other companies to share information about you</li>
                    <li>Where your information is publically available</li>
                    <li>Are the customer of a business that we acquire</li>
                </ul>
            </div>
            <div>
                <p>
                    We also collect information from certain organisations, where appropriate and to the extent we have legal grounds to
                    do so. These include fraud-prevention agencies, business directories, credit check reference/vetting agencies, billing
                    calculating agencies and connected network providers.
                </p>
                <p>
                     When you visit our premises, we may also collect information about you on CCTV as part of our security and crime
                    prevention measures.
                </p>
                <p>

                    We use cookies (small text files stored in your browser) and other techniques such as web beacons (small, clear
                    picture files used to follow your movements on our website). For more details on this and how to opt out of these,
                    please see the 'Cookies' policy.
                </p>
                <div>
                    <p>
                        The types of information we may have are, where applicable:
                    </p>
                    <ul>
                        <li>Your name, address, phone and/or mobile number, your date of birth, gender and email address.</li>
                        <li>Your traffic data. This is data we see as part of providing you with connectivity, like the numbers you call, the time and duration of the call or how you are using data.</li>
                        <li>Your location data. This can be precise where it uses Global Positioning System (GPS) data or by identifying nearby mobile phone masts and Wi-Fi hotspots and you enable location-based services or features. Or less precise where, for example, a location is derived from your IP address or data such as a post code or name of a town or city.</li>
                        <li>Your contact with us, such as a note or recording of a call you make to one of our contact centres, a Live Chat, an email or letter sent, or other records of any contact with us.</li>
                        <li>Your account information, such as dates of payment owed or received, subscriptions you use, account numbers or other information related to your account or included in the app.</li>
                        <li>Credential information - we'll collect passwords, hints and similar security information used for authentication and access to accounts and services.</li>
                        <li>Your preferences for particular products, services and lifestyle activities when you tell us what they are, or we assume what they are, based on how you use the products and services.</li>
                        <li>See the 'Cookies' policy for details on what we collect using cookies, web beacons and other technologies, including ad data.</li>
                        <li>Information we obtain from other sources, such as credit agencies, fraud-prevention agencies, and from other data providers. This includes demographic data, interest-based data, and internet browsing behaviour.</li>
                    </ul>
                </div>
                <div>
                    <p>
                    We'll also get information about how you use our products and services, such as:
                    </p>
                    <ul>
                        <li>The level of service that you receive - for example, network or service faults and other events that may
                            affect our network services or other services;</li>
                        <li>Details of your use of the specific services or products, for example: every time you use your mobile
                            phone, a record is kept. This includes the number you called or sent a text or picture message to, the length,
                            date and time of that call, text or picture message and your approximate location at the time that the
                            communication takes place (based on the location of the nearest cell that you sent that call or message
                            from). The same is also recorded every time you receive an incoming call or message. We don't, however,
                            keep a record of the content of your calls or messages.</li>
                    </ul>
                </div>
            </div>
            <div>
                <h3>
                    How we use your personal information
                </h3>
                <p>
                    We will use your personal information for the following purposes:
                </p>
                <ol>
                    <li>
                        To provide you with your service
                    </li>
                    <div>

                        <p>Processing your order and providing you with your products and services</p>
                        <ul>
                            <li>To process the products and services to you. This includes other services not included in your agreement with us(PayPal, for example),
                                services that use information about where your are, and to contact with you messages about changes to the products or services.
                            </li>
                        </ul>
                        <p>Billing and Customer Care</p>
                        <ul>
                            <li>To bill you for using our products and services, or to take the appropriate amount of credit from you.</li>
                            <li>Contact you if the billing information you provided us with is about to expire or we're not able to take payment.</li>
                            <li>To respond to any questions or concerns you may have about our network, products or services</li>
                        </ul>
                        <p>Service Messages</p>
                        <ul>
                            <li>We will contact you with customer service messages to keep you updated with current information about products and services you've taken.
                                For example, changes to our terms and conditions or service interruptions.
                            </li>
                        </ul>
                        <p>Providing roaming services</p>
                        <ul>
                            <li>To improve your roaming experiences, to ensure that we're meeting our commitments around fair use, to detect and resolve fraudulent use of our networks
                                (and our partners' roaming networks) and to solve technical issues if you are experiencing any.
                            </li>
                            <li>To understand how Vodafone is performing in providing roaming services, whether roaming services and related products are working as intended, or
                                whether improvements are need to make roaming better.
                            </li>
                        </ul>
                        <p>Vodafone uses personal data such as your name, email address, password, mobile phone number and call records in order to do this. Vodafone creates aggregated and 
                            statistical management reports from this information that do not identify you individually. Vodafone may also take this personal data and annoymise it so that more in-depth
                            analysis of our roaming services can be undertaken. This helps Vodafone to develop its roaming services for customers without identifying users in an individual way.
                        </p>
                    </div>
                    <li>To improve our service</li>
                    <div>
                        <p>Improving and innovating our products and services</p>

                        <ul>
                            <li>We collect anonymous, de-identified or aggregate information in order to improve the service we offer to
                                everyone. None of these analytics are linked back to you in any way.</li>
                        </ul>
                        <p>Managing our networks and understanding network usage</p>

                        <ul>
                            <li>To protect our networks and manage the volumes of calls, texts and other uses of our networks. For
                                example, we identify peak periods of use so we can try and ensure the networks can handle the volume at
                                those times.</li>
                            <li>
                                To understand how you use our networks, products and services. That way we can seek to review and
                                improve these, and develop more interesting and relevant products and services, as well as personalising
                                our products and services.
                            </li>
                        </ul>
                    </div>
                    <li>Marketing and tailoring our service to you</li>
                    <div>
                        <p>Marketing</p>
                        <ul>
                            <li>
                                As our customer, we will keep you informed generally about new and existing products and services, send
                                you newsletters or white papers, invite you to participate in market research or let you know about offers,
                                promotions, prize draws or competitions. We tailor these messages for example, based on the sorts of
                                products and services you've bought from us.
                            </li>
                            <li>
                                If you have given your permission, we will also contact you to let you know about products and services
                            </li>
                            <li>
                                There are various ways that we may do this - for example, by email, post, phone, text, picture message or
                                notifications through our apps.
                            </li>
                        </ul>

                        <p>Advertising Online</p>
                        <ul>
                            <li>
                                To deliver advertising that is relevant to you, you'll also see targeted advertising online based on the use of
                                cookies. This is known as interest-based advertising. It can be on websites belonging to the Vodafone
                                Group, those of other organisations as well as other online media channels such as social media sites. We
                                may also combine data collected via the cookies with other data we have collected. If you don't want any
                                information processed through the use of cookies, check the 'Cookies' section in this Privacy Portal. It
                                explains how to control and opt out of cookies.
                            </li>
                            <li>
                                Remember that opting out of interest-based advertising doesn't stop advertisements from being displayed -
                                it's just that they won't be tailored to your interests.
                            </li>
                            <li>
                                You will also see advertising in your social media, for example in your Facebook or Twitter feed. If you
                                don't want to receive this advertising, go to the relevant platform's ad settings.
                            </li>
                        </ul>
                    </div>
                    <li>Research and analytics</li>
                    <div>
                        <p>
                            We use a variety of analytics methods including what is commonly referred to as “Big data analytics”. Big data
                            analytics are mathematically driven analysis techniques on large and varied data sets (that is why it is “big” data) to
                            uncover hidden patterns and hitherto unrevealed trends. At Vodafone we take governance of big data analytics
                            seriously. Our data scientists are required to sign up to a Code of Ethics. We have a strict use case process that
                            requires that privacy and data protection law checks are carried out before any use case commences. We also have
                            strict rules ensuring that personal information is anonymised or de-identified at the appropriate stage in the process.
                        </p>
                        <p>We use our analytics to, for example:</p>
                        <ul>
                            <li>
                                Conduct market research and to carry out research and statistical analysis, including to monitor how
                                customers use our networks, products and services;
                            </li>
                            <li>
                                Frame our marketing campaigns and determine how we might personalise those;
                            </li>
                            <li>
                                Provide reports to third parties (such reports don't contain information which may identify you as an
                                individual). For example, as part of Vodafone Analytics
                            </li>
                        </ul>
                    </div>
                    <li>Credit checks, fraud prevention and security</li>
                    <div>
                        <p>We will sometimes need to profile you, for credit, fraud and security purposes.</p>
                        <p>Credit checks and ID</p>
                        <ul>
                            <li>We will carry out a credit check when you apply for a contract for any products or services with us.</li>
                            <li>We will also use your personal information for identity verification purposes, for access to your account
                                and for general account management. We sometimes supplement the information we collect about you with
                                information from other sources (for example, the electoral roll and credit reference agencies) to assess the
                                accuracy of the information that we hold.</li>
                        </ul>
                        <p>
                            Fraud prevention and security
                        </p>

                        <ul>
                            <li>we will process your personal and traffic data in order to protect against and detect fraud, to protect and 
                                detect misuse or damage to our networks, to receover debts or trace those who owe us money resulting from the use
                                of our services.
                            </li>
                        </ul>
                    </div>
                </ol>
            </div>

            <div>

                <h3>Keeping your personal information secure</h3>
                <p>
                    We have specialised security teams who constantly review and improve our measures to protect your personal
                    information from unauthorised access, accidental loss, disclosure or destruction.
                </p>
                <p>
                    We cannot accept responsibility for any unauthorised access or loss of personal information that is beyond our control.
                </p>
                <p>
                    We'll never ask for your secure personal or account information by an unsolicited means of communication. You're responsible
                    for keeping your personal and account information secure and not sharing it with others.
                </p>
                <p>
                    Our website may provide links to third-party websites. We cannot be responsible for the security and content of such third-party
                    websites. So make sure you read that company's privacy and cookies policies before using or putting your personal information
                    on their site.
                </p>
                <p>
                    The same applies to any third-party websites or content you connect to using our products and services.
                </p>
                <p>
                    You may choose to disclose your information in certain ways such as social plug-ins(including those offered by Google, Facebook , Twitter, Pinterest) 
                    or using third-party services that allow you to post reviews or other information publicly, and a third party could use that information.
                </p>
                <p>
                    Social plug-ins and social applications are operated by the social network themselves and are subject to their own terms of use and privacy 
                    and cookies policies. You should make sure you're familiar with these.
                </p>
            </div>

            
        </div>
    
    )
}

export default PrivacyPolicy;